import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import axios from "axios";
import CustomerStatement from "../CustomersPage/CustomerStatement";

const AccountStatementPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [popUp, setPopUp] = useState({
    title: "",
    description: "",
    isError: false,
    showPopUp: false,
    hideCancel: false,
  });

  const callPopUp = (props) => {
    setPopUp({ ...popUp, ...props });
    if (props.showPopUp) {
      setTimeout(() => {
        setPopUp({ ...popUp, showPopUp: false });
      }, 3000);
    }
  };

  useEffect(() => {
    const checkAccessAndFetchUser = async () => {
      const currentRole = getCookie("_r");
      const adminRole = process.env.REACT_APP_ADMIN_ROLE;
      const financeRole = process.env.REACT_APP_FINANCE_ROLE;
      const clientRole = process.env.REACT_APP_CLIENT_ROLE;
      const rentalPartnerRole = process.env.REACT_APP_RENTAL_PARTNER_ROLE;

      if (
        currentRole !== adminRole &&
        currentRole !== financeRole &&
        currentRole !== clientRole &&
        currentRole !== rentalPartnerRole
      ) {
        navigate("/", { replace: true });
        return;
      }

      try {
        const token = getCookie("_AT");
        if (!token) return;

        const response = await axios.get(`${config.apiUrl}/api/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };

    checkAccessAndFetchUser();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-start bg-gray-100 p-6 min-h-screen">
       <div className="w-full bg-white p-6 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold mb-6 text-gray-800">Account Statement</h1>
          <CustomerStatement callPopUp={callPopUp} userData={userData} />
       </div>

      {/* Popup Notification */}
      {popUp.showPopUp && (
        <div
          className={`fixed top-4 right-4 z-50 px-6 py-4 rounded shadow-lg text-white ${
            popUp.isError ? "bg-red-500" : "bg-green-500"
          }`}
        >
          <p className="font-bold">{popUp.title}</p>
          <p>{popUp.description}</p>
        </div>
      )}
    </div>
  );
};

export default AccountStatementPage;
